import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";

//i18b
import { withTranslation } from "react-i18next";

//Import images

import school from "../../assets/images/brands/school.jpg"

class NotificationDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menu: false
        };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(prevState => ({
            menu: !prevState.menu
        }));
    }
    render() {
        return (
            <React.Fragment>
                <Dropdown isOpen={this.state.menu} toggle={this.toggle} className="d-inline-block">
                    <DropdownToggle tag="button" className="btn header-item noti-icon waves-effect" id="page-header-notifications-dropdown">
                        <i className="ri-notification-3-line"></i>
                        <span className="noti-dot"></span>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end dropdown-menu-lg p-0"
                        aria-labelledby="page-header-notifications-dropdown">
                        <div className="p-3">
                            <Row className="align-items-center">
                                <Col>
                                    <h6 className="m-0"> {this.props.t('Notifications')} </h6>
                                </Col>
                                <div className="col-auto">
                                    <Link to="#" className="small"> {this.props.t('View All')}</Link>
                                </div>
                            </Row>
                        </div>
                        <SimpleBar style={{ maxHeight: "230px" }}>

                            <Link to="#" className="text-reset notification-item">
                                <div className="d-flex">
                                    <img src={school} className="me-3 rounded-circle avatar-xs" alt="user-pic" />
                                    <div className="flex-1">
                                        <h6 className="mt-0 mb-1">{this.props.t('Welcome to Brandstrek')}</h6>
                                        <div className="font-size-12 text-muted">
                                            {/* <p className="mb-1">{this.props.t('The final exam schedule has been updated. Ensure all teachers and students are notified.')}</p> */}
                                            {/* <p className="mb-0"><i className="mdi mdi-clock-outline"></i> {this.props.t('5 minutes ago')}</p> */}
                                        </div>
                                    </div>
                                </div>
                            </Link>

                            {/* <Link to="#" className="text-reset notification-item">
                                <div className="d-flex">
                                    <img src={school} className="me-3 rounded-circle avatar-xs" alt="user-pic" />
                                    <div className="flex-1">
                                        <h6 className="mt-0 mb-1">{this.props.t('School Event Approval')}</h6>
                                        <div className="font-size-12 text-muted">
                                            <p className="mb-1">{this.props.t('A request for the Annual Science Fair has been submitted.')}</p>
                                            <p className="mb-0"><i className="mdi mdi-clock-outline"></i> {this.props.t('14 hours ago')}</p>
                                        </div>
                                    </div>
                                </div>
                            </Link> */}

                            {/* <Link to="#" className="text-reset notification-item">
                                <div className="d-flex">
                                    <img src={school} className="me-3 rounded-circle avatar-xs" alt="user-pic" />
                                    <div className="flex-1">
                                        <h6 className="mt-0 mb-1">{this.props.t('Holiday Announcement')}</h6>
                                        <div className="font-size-12 text-muted">
                                            <p className="mb-1">{this.props.t('The school will remain closed on March 8,Inform all staff and students.')}</p>
                                            <p className="mb-0"><i className="mdi mdi-clock-outline"></i> {this.props.t('1 day ago')}</p>
                                        </div>
                                    </div>
                                </div>
                            </Link> */}

                            {/* <Link to="#" className="text-reset notification-item">
                                <div className="d-flex">
                                    <img src={school} className="me-3 rounded-circle avatar-xs" alt="user-pic" />
                                    <div className="flex-1">
                                        <h6 className="mt-0 mb-1">{this.props.t('New Admission Request')}</h6>
                                        <div className="font-size-12 text-muted">
                                            <p className="mb-1">{this.props.t('A new student admission request has been received.')}</p>
                                            <p className="mb-0"><i className="mdi mdi-clock-outline"></i> {this.props.t('5 days ago')}</p>
                                        </div>
                                    </div>
                                </div>
                            </Link> */}

                            {/* <Link to="#" className="text-reset notification-item">
                                <div className="d-flex">
                                    <img src={school} className="me-3 rounded-circle avatar-xs" alt="user-pic" />
                                    <div className="flex-1">
                                        <h6 className="mt-0 mb-1">{this.props.t('Fee Payment Alert')}</h6>
                                        <div className="font-size-12 text-muted">
                                            <p className="mb-1">{this.props.t('A new fee payment has been received. Check the finance dashboard for details.')}</p>
                                            <p className="mb-0"><i className="mdi mdi-clock-outline"></i> {this.props.t('10 days ago')}</p>
                                        </div>
                                    </div>
                                </div>
                            </Link> */}
                        </SimpleBar>
                        <div className="p-2 border-top">
                            <Link to="#" className="btn btn-sm btn-link font-size-14 btn-block text-center">
                                <i className="mdi mdi-arrow-right-circle me-1"></i>{this.props.t(' View More')}
                            </Link>
                        </div>
                    </DropdownMenu>
                </Dropdown>
            </React.Fragment>
        );
    }
}
export default withTranslation()(NotificationDropdown);
